import React, { useState } from "react";
import PowerPointPreview from "../../../../../components/PowerPointPreview";
import ExcelPreview from "../../../../../components/ExcelPreview";

function ViewDocument(props) {
  const [selectedFolder, setSelectedFolder] = useState(null);

  const hideApproveRejectDoc = (e) => {
    e.preventDefault();
    props.setDocDetail({
      id: 0,
      envelope_id: 0,
      recipient_id: 0,
      is_call: false,
      doc_detail: {}
    });
    setSelectedFolder(null);
  };

  // Helper to check if upload_file_list is array or object
  const getUploadFileListType = (upload_file_list) => {
    if (Array.isArray(upload_file_list)) return 'array';
    if (upload_file_list && typeof upload_file_list === 'object') return 'object';
    return null;
  };

  const upload_file_list = props?.docDetail?.doc_detail?.upload_file_list;
  const type = getUploadFileListType(upload_file_list);

  // Helper to render the appropriate file preview based on extension
  const renderFilePreview = (item) => {
    const ext = item.ext ? item.ext.toLowerCase() : '';

    if (ext === 'doc' || ext === 'docx') {
      return (
        <iframe style={{ width: '100%', height: '350px' }}
          src={`https://docs.google.com/gview?url=${item.file_path}&embedded=true`}
          title={item.file_name} allowFullScreen />
      );
    } else if (ext === 'ppt' || ext === 'pptx') {
      return <PowerPointPreview filePath={item.file_path} />;
    } else if (ext === 'csv') {
      return <ExcelPreview filePath={item.file_path} />;
    } else if (['jpg', 'jpeg', 'png', 'JPG', 'JPEG', 'PNG'].includes(ext)) {
      return (
        <img
          src={item.file_path}
          alt={item.file_name}
          style={{
            maxWidth: '100%',
            maxHeight: '350px',
            objectFit: 'contain'
          }}
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = 'https://via.placeholder.com/400x300?text=Image+Not+Found';
          }}
        />
      );
    } else {
      return (
        <iframe src={item.file_path} style={{ width: '100%', height: '350px' }}
          title={item.file_name} allowFullScreen />
      );
    }
  };

  return (
    <div className="offcanvas offcanvas-end ManageDocument w-80" data-bs-scroll="false" tabIndex="-1"
      data-bs-keyboard="true" data-bs-backdrop="static" id="viewDocument" aria-labelledby="viewDocumentLabel">
      <div className="offcanvas-header">
        <h5 className="offcanvas-title" id="viewDocumentLabel">Document View
          - {props?.docDetail?.doc_detail?.doc_name}</h5>
        <button type="button" className="btn btn-close close_btn text-reset " data-bs-dismiss="offcanvas"
          onClick={hideApproveRejectDoc} aria-label="Close">
          <i className="bi bi-x-circle" aria-hidden="true" />
        </button>
      </div>
      <div className="offcanvas-body">
        <div className="mx-lg-3 mb-3" id="doc_view">
          {/* New format: Folders as cards */}
          {type === 'object' && !selectedFolder && (
            <div className="row g-4">
              {Object.keys(upload_file_list).map((folder, idx) => (
                <div className="col-md-4 col-lg-3 col-12" key={folder}>
                  <div className="file-card file-card-folder folder-border " style={{ cursor: 'pointer', borderRadius: '18px', background: '#fff7eb' }} onClick={() => setSelectedFolder(folder)}>
                    <div className="card-body d-flex flex-column align-items-center justify-content-center">
                      <div className="file-icon-container my-3">
                        <span className="badge bg-secondary me-2" style={{ fontSize: '1rem', borderRadius: '50%', position: "absolute", top: "10%", left: "10%" }}>{upload_file_list[folder].length}</span>
                        <span style={{
                          fontSize: '2.5rem', color: '#ffd600', background: '#ece7e7',
                          height: "60px",
                          width: "60px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          borderRadius: "50%",
                        }}><i className="bi bi-folder-fill" /></span>
                      </div>
                      <h5 className="file-name">{folder}</h5>
                      {/* <div className="text-primary mt-2" style={{ fontSize: '0.95rem', letterSpacing: '0.5px' }}>FOLDER</div> */}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* New format: Files inside a folder */}
          {type === 'object' && selectedFolder && (
            <div>
              <button className="btn btn-link mb-3 px-0 text-decoration-none  fs-4 bg-black text-white rounded px-3 py-1 d-flex justify-content-end" onClick={() => setSelectedFolder(null)}>
                <i className="bi bi-arrow-left me-2 " />Back
              </button>
              <div className="accordion mb-3" id="doc_view_folder">
                {upload_file_list[selectedFolder].map((item, index) => (
                  <div key={index} className="accordion-item">
                    <h2 className="accordion-header " id={`docView_${index}`}>
                      <button className="accordion-button py-0" type="button" data-bs-toggle="collapse"
                        data-bs-target={`#Doc-View-${index}`} aria-expanded="true"
                        aria-controls={`Doc-View-${index}`}>{item.file_name}</button>
                    </h2>
                    <div id={`Doc-View-${index}`} className="accordion-collapse collapse show"
                      aria-labelledby={`docView_${index}`} data-bs-parent="#doc_view_folder">
                      <div className="accordion-body">
                        {renderFilePreview(item)}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Old format: Array of files */}
          {type === 'array' && (
            <div className="accordion mb-3" id="doc_view">
              {upload_file_list.map((item, index) => (
                <div key={index} className="accordion-item">
                  <h2 className="accordion-header " id={`docView_${index}`}>
                    <button className="accordion-button py-0" type="button" data-bs-toggle="collapse"
                      data-bs-target={`#Doc-View-${index}`} aria-expanded="true"
                      aria-controls={`Doc-View-${index}`}>{item.file_name}</button>
                  </h2>
                  <div id={`Doc-View-${index}`} className="accordion-collapse collapse show"
                    aria-labelledby={`docView_${index}`} data-bs-parent="#doc_view">
                    <div className="accordion-body">
                      {renderFilePreview(item)}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default ViewDocument;